import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetInterserviceAddrDropdownListQuery } from '../../../../../../../api';
import { useLanguage } from '../../../../../../../contexts/LanguageContext';

export const InterserviceAddrDropdown = ({ value, onChange, selectType, className }) => {
    const { th } = useLanguage();

    const { data, isLoading } = useGetInterserviceAddrDropdownListQuery(selectType);

    const options =
        data?.data?.map((opt) => ({
            id: opt.id,
            label: opt.shortName || opt.fullName
        })) || [];

    return (
        <Dropdown
            value={value}
            options={options}
            onChange={(e) => onChange(e.value)}
            optionLabel="label"
            optionValue="id"
            placeholder={th('customerAddressBrand.tabs.addrReport.placeholder.selectServiceAddress')}
            loading={isLoading}
            showClear
            filter
            disabled={!selectType}
            className={className}
        />
    );
};
